import styled, { css } from "styled-components";
import { ReactSVG } from "react-svg";

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const Main = styled.main`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    width: 100%;
  `}
`;

export const Label = styled.main`
  ${({ theme }) => css`
    font-weight: 500;
    padding-bottom: 1px;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.medium};
    font-family: Roboto !important;
    line-height: 2.5rem;
  `}
`;
